// Global CSS supplies Humanteq defaults. Products override only their colors.
// Keep the two native system-bar backgrounds in hex (Android/iOS contract).
export const humanteqTheme = { '--bg-start': '#98CCF0', '--bg-primary': '#F7F7F7' }

const accent = '#92566F'
const background = '#FAF8F9'
const soft = '#EDE0E7'

export const breakUpTheme = {
  '--bg-start': background,
  '--bg-end': soft,
  '--bg-primary': background,
  // #4486: the register step rides the shared onboarding shell — keep it on
  // the flat breakup canvas instead of the humanteq blue gradient (default
  // lives in global.css :root --onboarding-screen-bg).
  '--onboarding-screen-bg': 'var(--bg-primary)',
  '--app-bg-end': '#F3E7EC',
  '--bg-secondary': '#FFFFFF',
  '--surface': '#FFFFFF',
  '--text-primary': '#332B30',
  '--text-secondary': '#6F656A',
  '--text-muted': '#82747C',
  '--link': accent,
  '--button-default': accent,
  '--button-hover': '#7D455C',
  '--button-active': '#6B394E',
  '--border': '#E5D8DF',
  '--tag': soft,
  '--tertiary-default': '#F5EEF2',
  '--tertiary-hover': soft,
  '--tertiary-active': '#DFCCD6',
  '--input-focus': accent,
  // These existing tokens also style cards, chat avatars and selection states.
  '--blue-accent': accent,
  '--blue-light': soft,
  '--blue-strong': accent,
  '--blue-soft': '#F5EBEF',
  '--blue-grad': `linear-gradient(160deg, ${soft} 0%, ${background} 100%)`,
  '--blue-card': `radial-gradient(ellipse at top left, ${background} 0%, ${soft} 100%)`,
  '--faq-card': 'var(--blue-card)',
  // Overrides for legacy accents whose default shades differ between screens.
  '--accent': accent,
  '--accent-rgb': '146, 86, 111',
} satisfies Record<`--${string}`, string>
